export enum LinkedinFeedPeriod {
  PAST_24H = "past-24h",
  PAST_WEEK = "past-week",
  PAST_MONTH = "past-month",
}
